import { render, staticRenderFns } from "./VTimeline.vue?vue&type=template&id=3e8844e6&"
import script from "./VTimeline.vue?vue&type=script&lang=js&"
export * from "./VTimeline.vue?vue&type=script&lang=js&"
import style0 from "./VTimeline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports